import { withRequestDeadline } from "@softmax/observatory-client/request-signal";

import { participationGuidePath } from "@softmax/web-features/coworlds";

export async function readParticipationGuide({
  signal,
  leagueId,
}: {
  signal?: AbortSignal | undefined;
  leagueId: string;
}): Promise<string> {
  let response: Response;

  try {
    response = await fetch(
      `/api/observatory${participationGuidePath(leagueId)}`,
      {
        headers: { "x-observatory-public-path": "1" },
        credentials: "omit",
        cache: "no-store",
        signal: withRequestDeadline(signal, participationGuideFetchTimeoutMs),
      },
    );
  } catch {
    return "";
  }

  return response.ok ? response.text() : "";
}

const participationGuideFetchTimeoutMs = 8000;
